// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2Fr1x","description":"PatientConsentPreview_description__25UVR"};